/* unplugin-vue-components disabled */import script from "./AlarmBall.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmBall.vue?vue&type=script&setup=true&lang=js"

import "./AlarmBall.vue?vue&type=style&index=0&id=d9d681a8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9d681a8"]])

export default __exports__